import { contactsRouteNames, tasksRouteNames, businessRouteNames, locationSettingsRouteNames } from '@/routes/constants/location'

// Embedded forms
export const STICKY_SIDEBAR = 'STICKY_SIDEBAR';
export const POLITE_SLIDE_IN = 'POLITE_SLIDE_IN';
export const POPUP = 'POPUP';
export const INLINE = 'INLINE';

// Company identifiers
// export const FEATURE_CONTROLLED_COMPANY_ID = 'Hke8ke8XE1SnTXfKJxiK'; //FastpayDirect Agency
// export const FEATURE_CONTROLLED_LOCATION_ID = 'B8tpvNOPVyxo4UPtDNnj'; // Internal location
export const FEATURE_CONTROLLED_COMPANY_ID = '87zFIHuzEZZjY6G2qOhz'; // Test Agency
export const FEATURE_CONTROLLED_LOCATION_ID = 'i07YIlSG20lGJ5MSXrGK'; // Test Location
// FORM LAYOUTS URLS
export const FORM_LAYOUT_URLS = {
	STICKY_SIDEBAR: 'https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar.png',
	POLITE_SLIDE_IN: 'https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in.png',
	STICKY_SIDEBAR_RIGHT: 'https://stcdn.leadconnectorhq.com/forms/img/polite-slide-in-right.png',
	POLITE_SLIDE_IN_LEFT: 'https://stcdn.leadconnectorhq.com/forms/img/sticky-sidebar-left.png',
	POPUP: 'https://stcdn.leadconnectorhq.com/forms/img/popup-layout.png',
	INLINE: 'https://stcdn.leadconnectorhq.com/forms/img/inline-layout.png',
};
export const CARD_LAYOUTS = [
	{
		id: 'STICKY_SIDEBAR',
		image: FORM_LAYOUT_URLS.STICKY_SIDEBAR,
		name: 'Sticky sidebar',
		allowMinimize: false,
		minimizedTitle: '',
		isLeftAligned: true,
		isRightAligned: false,
		description:
			'A Sticky sidebar will appear on the side of the screen and can be minimized to a tab that sticks to the side of the window',
		hoverDescription: 'Appear on the side of the screen and can be minimized to a tab that sticks to the side of the window'
	},
	{
		id: 'POLITE_SLIDE_IN',
		image: FORM_LAYOUT_URLS.POLITE_SLIDE_IN,
		name: 'Polite slide-in',
		allowMinimize: false,
		minimizedTitle: '',
		isLeftAligned: false,
		isRightAligned: true,
		description:
			'A polite slide-in appears on the bottom side of screen and disappears once closed',
		hoverDescription: 'Appears on the bottom side of screen and disappears once closed'
	},
	{
		id: 'POPUP',
	  image: FORM_LAYOUT_URLS.POPUP,
		name: 'Popup',
		description: 'A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.',
		hoverDescription: 'A pop-up shows form as an overlay inside a light-box. It cannot be minimized but closed.'
	},
	{
		id: 'INLINE',
		image: FORM_LAYOUT_URLS.INLINE,
		name: 'Inline',
		description: 'An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.',
		hoverDescription: 'An inline form appears along with the content of the page as a native element. It does not overlay and cannot be closed or minimized.'
	},
];

export const TRIGGERS = [
	{ id: 'showOnScrolling', name: 'Show on scrolling', showInput: true },
	{ id: 'showAfter', name: 'Show after', showInput: true },
	{ id: 'alwaysShow', name: 'Always show', showInput: false },
];

export const ACTIVATION_OPTIONS = [
	{ id: 'activateOnVisit', name: 'Activate on', showInput: true },
	{ id: 'alwaysActivated', name: 'Always activated', showInput: false },
];

export const DEACTIVATION_OPTIONS =  [
	{
		id: 'deactivateAfter',
		name: 'Deactivate after showing',
		showInput: true,
	},
	{
		id: 'leadCollected',
		name: 'Deactivate once lead is collected',
		showInput: false,
	},
	{ id: 'neverDeactivate', name: 'Never deactivate', showInput: false },
];

export const AUTHORIZE_NET = 'authorize-net'
export const NMI = 'nmi'
export const STRIPE = 'stripe'
export const COURSES = 'courses'

export enum AttributionMediums { Manual = "manual", Conversation = "conversation" }
export enum AttributionSource { CrmUI ='CRM UI', Others = 'Other' }

export const STAR_SHIP_A_RECORD = '104.18.185.50'

export enum SHOP_STATE { PENDING_ON_YEXT = 'PENDING_ON_YEXT', ACCOUNT_CREATION = 'ACCOUNT_CREATION', YEXT_PAYMENT = 'YEXT_PAYMENT', PITCH = 'PITCH' }

export enum STRIPE_STATUS { UNSUBSCRIBED = 'UNSUBSCRIBED', COMPLETE = 'COMPLETE', UNSUBSCRIBED_STRIPE = 'UNSUBSCRIBED_STRIPE' }

export const YEXT_AVAILABLE_IN_COUNTRIES = ['US', 'GB', 'CA', 'AU', 'IT', 'FR', 'DE']

export const EMAIL_PROVIDERS = {
	SMTP: 'smtp',
	MAILGUN: 'mailgun',
	LEADCONNECTOR: 'leadconnector',
	OTHER: 'other'
}

export const CONTACT_MENU_ROUTES = [locationSettingsRouteNames.smartList, businessRouteNames.default, tasksRouteNames.default, contactsRouteNames.contactRestore, contactsRouteNames.bulkActions, contactsRouteNames.smartList]
export const IP_PRODUCT_ID = 'EmailIP'

export const PREMIUM_PLAN_STARTING_PRICE = 497
export const AD_PUBLISHING_ID = 'Ad_Publishing'
export const AD_MANAGER_AGENCY_DEFAULT_MARKUP = 10
export const AD_MANAGER_CONNECT_BM_DEFAULT_PRICE = 30
export const NEW_MESSAGE_FLOW_CONVERSATION_ID = 'new-conversation'
export const AD_PUBLISHING_CONNECT_BM_LOCATION = 'Ad_Publishing_Connect_Your_BM_Location'
export const AUTOMATION_AD_MANAGER_AGENCY_PLAN_SELECTION_PENDO = 'automation_ad_manager_agency_plan_selection'
export const AD_PUBLISHING_STANDARD_PLAN = 'Ad_Publishing_Standard_Plan'
export const AD_PUBLISHING_STANDARD_PLAN_HL_PRICE = 10
export const ONLINE_LISTINGS_HL_PRICE = 30